const setupGoogleTagManager = () => {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  window.googletag.cmd.push(() => {
    let referrerPath = '';
    if (document.referrer) {
      const referrerParts = document.referrer.split('/');
      referrerPath = referrerParts[2];

      if (referrerPath === location.host) {
        if (referrerParts.length > 4) {
          referrerPath = `${referrerParts[2]}/${referrerParts[3]}/${referrerParts[4]}`;
        } else if (referrerParts.length > 3) {
          referrerPath = `${referrerParts[2]}/${referrerParts[3]}`;
        }
      }
    }

    const pathParts = location.pathname.split('/');
    let simplePath = '';

    if (pathParts.length > 2) {
      simplePath = `/${pathParts[1]}/${pathParts[2]}`;
    } else if (pathParts.length > 1) {
      simplePath = `/${pathParts[1]}`;
    }

    const fullPath = location.pathname;
    const lastPathSegment = pathParts[pathParts.length - 1];
    let targetingString = `${simplePath} ${referrerPath}`;
    targetingString = targetingString.split('=').join('_');
    
    window.googletag.pubads().setTargeting('itf', targetingString);
    window.googletag.pubads().setTargeting('itf1', fullPath);
    window.googletag.pubads().setTargeting('itf2', lastPathSegment);
    window.googletag.pubads().enableSingleRequest();
    window.googletag.enableServices();
  });
};

document.addEventListener('DOMContentLoaded', setupGoogleTagManager);
document.addEventListener('turbolinks:load', setupGoogleTagManager);
